// OUTBOUND EVENTS
export enum GeneralOutboundEvents {
    ReactLoaded = 'react_loaded',
    HBAppOpenFlow = 'hb_app_open_flow',
    HBAppOpenFile = 'hb_app_open_file',
    HBAppOpenBankDetails = 'hb_app_open_bank_details',
    BlockSelectedNavigation = 'block_selected_navigation',
    RootCreateBlockClicked = 'root_create_block_clicked',
    InnerCreateBlockClicked = 'inner_create_block_clicked',
    FlowValidationOnly = 'flow_validation_only',
    GoToWorkspace = 'go_to_workspace',
    EditField = 'edit_field',
    GetTemplate = 'get_template',
    ModalLoaded = 'modal_loaded',
    PublishFlow = 'publish_flow',
    FinishedCancelScheduleSend = 'finished_cancel_schedule_send',
    UnselectAllDone = 'unselect_all_done',
    UpdateInResponsesDone = 'update_in_responses_done',
    OpenEditBlockWarning = 'open_edit_block_warning',
    NavigateToEdit = 'navigate_to_edit',
    AddParticipant = 'add_participant',
    ServerError = 'server_error',
    IsDirtyFlow = 'is_dirty_flow',
    OnAttachmentClick = 'on_attachment_click',
    MergeFlowRevisions = 'merge_flow_revisions',
    NativeControllerLoaded = 'hb_app_native_controller_loaded',
    ViewLoaded = 'hb_app_view_loaded',
    NativeControllerHealthCheck = 'hb_app_native_controller_health_check',
    FlowLoaded = 'hb_app_flow_loaded',
    CloseModal = 'close_modal',
    YearInReviewShareClicked = 'year_in_review_share_clicked'
}

export enum ContractOutboundEvents {
    SmartFieldClicked = 'smart_field_clicked',
    SmartBoxClicked = 'smart_box_clicked',
    // todo: delete view_contract_clicked around December 23, it has been replaced by view_contract_modal_clicked
    ViewContractClicked = 'view_contract_clicked',
    ViewContractModalClicked = 'view_contract_modal_clicked',
    SignContractClicked = 'sign_contract_clicked'
}

export enum InvoiceOutboundEvents {
    PayBlockTbdClicked = 'pay_block_tbd_clicked',
    ReorderItemsClicked = 'reorder_items_clicked',
    UnitClicked = 'unit_clicked',
    AddTax = 'add_tax',
    EditTax = 'edit_tax',
    AddDiscount = 'add_discount',
    EditDiscount = 'edit_discount',
    DeleteServiceItemClicked = 'delete_service_item_clicked',
    AddItemPackageClicked = 'add_item_package_clicked',
    ServiceTaxesClicked = 'service_taxes_clicked',
    PaymentReceiptData = 'payment_receipt_data',
    PaymentDetailsData = 'payment_details_data',
    ServiceImageClicked = 'service_image_clicked',
    ViewInvoiceModalClicked = 'view_invoice_modal_clicked',
    PaymentActionError = 'payment_action_error',
    OpenPaymentOptions = 'open_payment_options',
    CreateNewInvoice = 'create_new_invoice'
}

export enum SchedulerOutboundEvents {
    ViewMeetingDetails = 'view_meeting_details'
}

export enum CoreOutboundEvents {
    BlockSelected = 'block_selected',
    BlockUnselected = 'block_unselected',
    PageLoaded = 'page_loaded',
    SelectClicked = 'select_clicked',
    UpdateBlockData = 'block_updated',
    FlowValidationStatus = 'flow_validation_status'
}

export enum PageOutboundEvents {
    PagesList = 'pages_list'
}

// INBOUND EVENTS

export enum CoreInboundEvents {
    CreateBlock = 'create_block',
    MoveBlock = 'move_block',
    GoToBlock = 'go_to_block',
    OnReorderItem = 'on_reorder_item',
    DeleteBlock = 'delete_block',
    UpdateBlock = 'update_block',
    UnselectBlock = 'unselect_block',
    UnselectAll = 'unselect_all'
}

export enum InvoiceInboundEvents {
    UpdateInvoiceHeaderBlock = 'update_invoice_header_block',
    UpdateInvoiceAppearanceColumnsBlock = 'update_invoice_appearance_columns_block',
    UpdateInvoiceAppearanceSummaryBlock = 'update_invoice_appearance_summary_block',
    CreateInvoiceBlock = 'create_invoice_block',
    CloseResponsesModal = 'close_responses_modal',
    CreatePaymentBlock = 'create_payment_block',
    UpdateChargeBlock = 'update_charge_block',
    UpdateContact = 'update_contact',
    UpdatePaymentBlock = 'update_payment_block',
    InvoiceServicesCreateNew = 'invoice_services_create_new',
    InvoiceServicesCreateFromExisting = 'invoice_services_create_from_existing',
    InvoiceServicesCreateFromHub = 'invoice_services_create_from_hub',
    MarkAsPaid = 'mark_as_paid',
    UndoMarkAsPaid = 'undo_mark_as_paid',
    MarkAsRefunded = 'mark_as_refunded',
    SendPaymentReminder = 'send_payment_reminder',
    OnUnitSelection = 'on_unit_selection',
    ViewPaymentDetails = 'view_payment_details',
    GoToInvoiceDisplay = 'go_to_invoice_display',
    UpdateServiceImage = 'update_service_image',
    ViewPaymentReceipt = 'view_payment_receipt',
    OnUpdateTax = 'on_update_tax',
    UpdateClientPaymentPlan = 'update_client_payment_plan'
}

export enum SchedulerInboundEvents {
    CancelSession = 'cancel_session'
}

export enum ContractInboundEvents {
    UpdateSignature = 'update_signature',
    AddSmartField = 'add_smart_field',
    UpdateAssigneeOfContract = 'update_assignee_of_contract',
    UpdateSmartField = 'update_smart_field'
}

export enum PageInboundEvents {
    GetPages = 'get_pages',
    SelectPage = 'page_selected',
    UpdatePage = 'update_page',
    DeletePage = 'delete_page',
    AddPage = 'add_page',
    DuplicatePage = 'duplicate_page',
    UpdatePageBackgroundImage = 'update_page_background_image'
}

export enum ReusableInboundEvents {
    ApplyReusableSFTemplate = 'apply_reusable_sf_template'
}

export enum GeneralInboundEvents {
    UpdateCompositionLayout = 'update_composition_layout',
    FinalizeSelectCompositionLayout = 'finalize_select_composition_layout',
    UpdateBlockColumns = 'update_block_columns',
    ApplyTemplate = 'apply_template',
    CloseModal = 'close_modal',
    GetTemplate = 'get_template',
    DesktopPreviewClicked = 'desktop_preview_clicked',
    MobilePreviewClicked = 'mobile_preview_clicked',
    GoToRoot = 'go_to_root',
    ValidateFlow = 'validate_flow',
    EditActions = 'edit_action',
    AddMember = 'add_member',
    PublishFlow = 'publish_flow',
    PublishAfterShare = 'publish_after_share',
    MergeFlowRevisions = 'merge_flow_revisions',
    CustomizeFlowAfterOnboarding = 'customize_flow_after_onboarding',
    StartOnboarding = 'start_onboarding'
}

export enum NavigationEvents {
    GoToTab = 'go_to_tab',
    GoToPreview = 'go_to_preview',
    GoToPreviewLoaded = 'go_to_preview_loaded',
    ExitPreview = 'exit_preview',
    CancelScheduleSend = 'cancel_schedule_send',
    CancelScheduleSendUIOnly = 'cancel_schedule_send_ui_only'
}

export const EditableFields = {
    ServiceQuantity: {
        key: 'service_quantity_and_price',
        label: 'Edit Quantity'
    },
    ServicePrice: {
        key: 'service_quantity_and_price',
        label: 'Edit unit price'
    },
    ServiceDescription: {
        key: 'service_description',
        label: 'Edit description'
    }
};
